import { pickBy, includes } from 'lodash'
import { getTimeline } from './timeline_selectors.js'

export function getTimespans(state, props) {
  return state.data.timespans
}

export function getTimespan(state, props, id) {
  const idString = id.toString()
  return getTimespans(state, props)[idString]
}

export function getTimespansForTimeline(state, props, timelineId) {
  const timeline = getTimeline(state, props, timelineId)
  const timespanIds = timeline.timespan_ids
  const allTimespans = getTimespans(state, props) || {}
  return pickBy(allTimespans, timespan => includes(timespanIds, timespan.id))
}
